module.exports = __webpack_public_path__ + "img/hourglass_3_fill.ce7045fd.svg";